import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadResumesActionsModalComponent } from './upload-resumes-actions-modal.component';
import { OverrideCandidateSuspensionModule } from 'src/app/shared/override-candidate-suspension/override-candidate-suspension.module';

@NgModule({
  declarations: [UploadResumesActionsModalComponent],
  imports: [
    CommonModule,
    OverrideCandidateSuspensionModule
  ],
  exports: [UploadResumesActionsModalComponent],
  entryComponents: [UploadResumesActionsModalComponent]
})
export class UploadResumesActionsModalModule { }
